import React from 'react';
import { Marker } from "react-leaflet";
import ConsolTooltip from "./ConsolTooltip.js";
import BaseMarker from "../../img/order.png";
import CompanionMarker from "../../img/supplier.png";
import OrderMarker from "../../img/order.png";
import BootsOnMarker from "../../img/boots_on.png";
import BootsOnStaleMarker from "../../img/boots_on_stale.png";
import ClashOrderMarker from "../../img/clash_order.png";
import SupplierSelectedMarker from "../../img/supplierSelected.png";
import SupplierMarker from "../../img/supplier.png";
import ShadowMarker from "../../img/shadow.png";

export default function ConsolMarker({ item, idx, mapType }) {
  var iconType;

  if (item.markerType == "base") {
    iconType = BaseMarker;
  } else if (item.markerType == "companion") {
    iconType = CompanionMarker;
  } else if (item.markerType == "order") {
    iconType = OrderMarker;
  } else if (item.markerType == "boots_on") {
    iconType = BootsOnMarker;
  } else if (item.markerType == "boots_on_stale") {
    iconType = BootsOnStaleMarker;
  } else if (item.markerType == "clash_order") {
    iconType = ClashOrderMarker;
  } else if (item.markerType == "supplierSelected") {
    iconType = SupplierSelectedMarker;
  } else if (item.markerType == "supplier") {
    iconType = SupplierMarker;
  }

  const markerIcon = new L.Icon({
    iconUrl: iconType,
    shadowUrl: ShadowMarker,
    iconSize: [35, 58], // size of the icon
    iconAnchor: [17, 55], // point of the icon which will correspond to marker's location
    popupAnchor: [1, -32], // point from which the popup should open relative to the iconAnchor
    shadowAnchor: [17, 55], // the same for the shadow
    shadowSize: [55, 58], // size of the shadow
  });

  return (
    <Marker
      key={idx}
      position={[item.lat, item.lng]}
      icon={markerIcon}
      markerType={item.markerType}
      bootsOnCount={item.bootsOnCount}
      bootsOnStaleCount={item.bootsOnStaleCount}
      noBootsCount={item.noBootsCount}
    >
      <ConsolTooltip item={item} mapType={mapType}></ConsolTooltip>
    </Marker>
  );
}
